// Imperative controller for the Google scope-picker modal.
//
// The modal must appear from several places (Accounts page, node sidebar,
// planner panel) without each one re-rendering its own copy. So it's mounted
// ONCE at the app root (GoogleScopePickerHost) and opened imperatively:
//
//   openGoogleScopePicker()
//     .then(function(sel) { /* sel = { name, scopes } */ })
//     .catch(function() { /* user cancelled */ });
//
// Only one picker can be open at a time; opening again while one is pending
// rejects the previous request.

var _listener = null;   // the host registers a render callback here
var _pending = null;    // { resolve, reject } for the in-flight open()

// The host calls this on mount to receive open/close signals.
function _subscribe(listener) {
  _listener = listener;
  return function unsubscribe() { if (_listener === listener) _listener = null; };
}

function openGoogleScopePicker() {
  return new Promise(function(resolve, reject) {
    // Reject any previous still-open request before starting a new one.
    if (_pending) { _pending.reject(new Error('superseded')); _pending = null; }
    _pending = { resolve: resolve, reject: reject };

    // The host registers _listener in a mount effect, which may not have run at
    // the instant of the very first click. Retry briefly before giving up so a
    // mount/effect race can't leave the caller hanging or failing silently.
    var tries = 0;
    (function attempt() {
      if (!_pending) return; // superseded/settled meanwhile
      if (_listener) { _listener(true); return; }
      if (tries++ > 40) { // ~2s
        var p = _pending; _pending = null;
        p.reject(new Error('Scope picker is not available. Please reload the page and try again.'));
        return;
      }
      setTimeout(attempt, 50);
    })();
  });
}

// Called by the host when the user confirms/cancels.
function _resolvePending(selection) {
  if (_listener) _listener(false);
  if (_pending) { _pending.resolve(selection); _pending = null; }
}
function _rejectPending() {
  if (_listener) _listener(false);
  if (_pending) { _pending.reject(new Error('cancelled')); _pending = null; }
}

module.exports = {
  openGoogleScopePicker: openGoogleScopePicker,
  _subscribe: _subscribe,
  _resolvePending: _resolvePending,
  _rejectPending: _rejectPending
};
